import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import localizedFormat from 'dayjs/plugin/localizedFormat'

import { getCookie } from './get-cookie'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localizedFormat)

export function getUsersTimeByZoneLTS(
  date: string | Date | null | undefined,
  format: string,
): string {
  if (!date) {
    return ''
  }

  let userTimeZone: string | null | undefined = getCookie('usersTimeZone')

  if (!userTimeZone) {
    userTimeZone = dayjs.tz.guess()
  }

  const currentUserDate = date
    ? dayjs.utc(date).tz(userTimeZone)
    : dayjs().tz(userTimeZone)

  return currentUserDate.format(format)
}
